import { render } from "./FloatingVideoPlayer.vue?vue&type=template&id=337ec0ae&scoped=true"
import script from "./FloatingVideoPlayer.vue?vue&type=script&lang=js"
export * from "./FloatingVideoPlayer.vue?vue&type=script&lang=js"

import "./FloatingVideoPlayer.vue?vue&type=style&index=0&id=337ec0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337ec0ae"]])

export default __exports__